import { render, staticRenderFns } from "./curSale-order-detail.vue?vue&type=template&id=013bdaf2&scoped=true"
import script from "./curSale-order-detail.vue?vue&type=script&lang=js"
export * from "./curSale-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013bdaf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013bdaf2')) {
      api.createRecord('013bdaf2', component.options)
    } else {
      api.reload('013bdaf2', component.options)
    }
    module.hot.accept("./curSale-order-detail.vue?vue&type=template&id=013bdaf2&scoped=true", function () {
      api.rerender('013bdaf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/curSale-management/curSale-order/curSale-order-detail.vue"
export default component.exports